export default "__VITE_ASSET__6d210866__"